import { FilterEvent } from '../filter-event/index.js';
import { coerce } from '@meltwater/coerce';

/**
 * The name of the event to use with `addEventListener`
 * @readonly
 * @constant {string}
 */
export const FILTER_EVENT_NAME = 'ua-filter-v2';

/**
 *  Dispatch a FilterEvent with a well known and versioned name from the provided domElement
 *
 * @param {object} options - See Below
 * @param {HTMLElement} options.domElement - The element the event will be dispatched from
 * @param {FilterEvent} options.filterEvent - The filter event to put in the details of the dispatched event
 * @returns {undefined}
 */
export function emitFilterEvent({
    domElement,
    filterEvent
}) {
    const safeFilterEvent = coerce(filterEvent, FilterEvent, `Malformed filter event provided. Provided value: ${JSON.stringify(filterEvent)}`);

    domElement.dispatchEvent(new CustomEvent(FILTER_EVENT_NAME, {
        detail: safeFilterEvent,
        bubbles: true,
        cancelable: true,
        composed: true
    }));
}
